import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-2c8baf6c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = {
  class: "inner-container"
};
var _hoisted_3 = {
  class: "title-container"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "title"
  }, "优秀作品", -1);
});
var _hoisted_5 = {
  class: "title-desc"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "查看更多", -1);
});
var _hoisted_7 = {
  class: "work-list-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ArrowRightOutlined = _resolveComponent("ArrowRightOutlined");
  var _component_router_link = _resolveComponent("router-link");
  var _component_ExcellentWorkList = _resolveComponent("ExcellentWorkList");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_router_link, {
    class: "link-more hover-link",
    to: "/excellent"
  }, {
    default: _withCtx(function () {
      return [_hoisted_6, _createVNode(_component_ArrowRightOutlined, {
        class: "icon-link-more"
      })];
    }),
    _: 1
  })])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_ExcellentWorkList, {
    list: _ctx.homeService.userCreationList
  }, null, 8, ["list"])])])]);
}